export function getAccountHomePath(userInfo = {}, fallbackAccountType = null) {
  const accountType = Number(
    userInfo?.accountType ?? fallbackAccountType ?? userInfo?.type
  );
  const hasUpload = Number(userInfo?.hasUpload);
  const tourist = !!userInfo?.tourist;

  switch (accountType) {
    case 0:
      return "/operateHome";
    case 1:
    case 4:
      return hasUpload === 0 ? "/uploadEntryClient" : "/clientHome";
    case 2:
      if (hasUpload === 0) return "/suppSelectCategory";
      if (hasUpload === 1) return "/suppEntryStudy";
      return "/mineSupp";
    case 3:
      return "/clientHome";
    case 5:
      return "/expertEnd/shareMaterialLibrary";
    case 6:
      return "/replenishment";
    case 7:
      return "/distributionSupplier";
    case 8:
      return tourist ? "/smallShop/loginHome" : "/smallShop/home";
    case 9:
      return "/exhibition";
    default:
      return "/login";
  }
}
